import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

	constructor(
		private authService: AuthService,
		private storageService: StorageService,
		private router: Router
	) { }

	intercept(req: HttpRequest<any>, next: HttpHandler) {

		const token = this.authService.getToken();

		// 1️⃣ LOGIN endpoint – skip authentication + skip redirect logic
		if (req.url.includes('/login')) {
			return next.handle(req); // ❗ Без catchError – оставяме AuthService да обработи
		}

		let authReq = req;
		if (token) {
			authReq = req.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`
				}
			});
		}

		return next.handle(authReq).pipe(
			catchError((err: HttpErrorResponse) => {

				// skipvame 403 shtoto tamima drugi greshki
				if (err.status === 401 /**|| err.status === 403 */) {
					console.warn("Token expired or not valid → redirect to login");

					// чистим всичко
					this.storageService.clear();

					// redirect
					this.router.navigate(['/login'], {
						queryParams: { expired: '1' }
					});
				}

				// 429 = Rate limit. Показваме съобщението от backend-а ако има,
				// иначе общо съобщение.
				if (err.status === 429) {
					const msg = (err.error && err.error.message)
						|| 'Колега, активирахте важна системна защита срещу flood и DDoS атаки — моля изчакайте 1-2 минути и продължете работа.';
					alert(msg);
				}

				return throwError(err);
			})
		);
	}
}
